<template>
  <div>
    <div class="algo-form">
      <div class="modal-body">
        <base-select
          v-if="selectedAppGroupOptions.length > 0"
          v-model="formItems.applicationId"
          @change="changeSelectedApp"
          id="application"
          :options="selectedAppGroupOptions"
          fieldLabel="Uygulama"
          placeholder="Uygulama Seç"
          :selected-id="formItems.applicationId"
        />
        <base-input
          v-model="formItems.name"
          inputType="text"
          labelText="Adı"
          :class="{ 'is-invalid': submitted && $v.formItems.name.$error }"
        />
        <div
          v-if="submitted && !$v.formItems.name.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.shortContent"
          inputType="text"
          labelText="Kısa Tanım"
        />
        <base-input
          v-model="formItems.description"
          inputType="text"
          labelText="Açıklama"
        />
        <base-input
          v-model="formItems.price"
          inputType="number"
          labelText="Fiyat"
          id="algoPrice"
          value="formItems.price"
          :allowDecimals="true"
          @change="calculate(formItems.price)"
          :class="{ 'is-invalid': submitted && $v.formItems.price.$error }"
        />
        <div
          v-if="submitted && !$v.formItems.price.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.priceCostMultiplier"
          inputType="number"
          labelText="Fiyat Maliyet Çarpanı"
          id="algoPriceCostMultiplier"
          :isDisabled="true"
          :class="{
            'is-invalid': submitted && $v.formItems.priceCostMultiplier.$error,
          }"
        />
        <div
          v-if="submitted && !$v.formItems.priceCostMultiplier.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.screenPrice"
          inputType="number"
          labelText="Ekran Ücreti"
          id="algoScreenPrice"
          :class="{
            'is-invalid': submitted && $v.formItems.screenPrice.$error,
          }"
        />
        <div
          v-if="submitted && !$v.formItems.screenPrice.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.cost"
          inputType="number"
          labelText="Maliyet"
          id="algoCost"
          :class="{
            'is-invalid': submitted && $v.formItems.cost.$error,
          }"
        />
        <div
          v-if="submitted && !$v.formItems.cost.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.fundAmount"
          inputType="number"
          labelText="Fon Miktarı"
          :isDisabled="true"
          id="algoFundAmount"
          :class="{
            'is-invalid': submitted && $v.formItems.fundAmount.$error,
          }"
        />
        <div
          v-if="submitted && !$v.formItems.fundAmount.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.commissionAmount"
          inputType="number"
          labelText="Komisyon Miktarı"
          :isDisabled="true"
          id="algoCommissionAmount"
          :class="{
            'is-invalid': submitted && $v.formItems.commissionAmount.$error,
          }"
        />
        <div
          v-if="submitted && !$v.formItems.commissionAmount.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <div
          v-for="(item, index) in additionalWarnings"
          :key="index"
          class="grouped-container with-button"
        >
          <base-input
            v-model="additionalWarnings[index]"
            inputType="text"
            labelText="Uyarılar"
            id="algoVdProducrtWarnings"
          />
          <div
            v-if="index === 0"
            @click.prevent="addRemoveAdditionalWarnings()"
            class="add-button"
          >
            <base-icon :name="'plus-circle'" />
          </div>
          <div
            v-else
            @click.prevent="addRemoveAdditionalWarnings(index)"
            class="add-button remove"
          >
            <base-icon :name="'close-colored'" />
          </div>
        </div>
        <br />
        <photo-upload :base64Img="setPhotoForForm" />
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('modal')"
          >Vazgeç</base-button
        >
        <base-button @click="sendForm" class="add"> Kaydet </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { BaseSelect, BaseInput, BaseButton, BaseIcon } from "@/components";
import { required } from "vuelidate/lib/validators";
import PhotoUpload from "@/components/productAndPackage/PhotoUpload";
import mixins from "../../mixins/index";

export default {
  name: "ResearchDefinitionForm",
  mixins: [mixins],
  props: {
    clickedNewItemBtn: Boolean,
    applicationId: Number,
    researchId: Number,
    selectedDataApplicationId: Number,
    selectedDataResearchId: Number,
    id: Number,
    selectedDataId: Number,
    name: String,
    selectedDataName: String,
    selectedDataOrder: Number,
    isHighLevel: Boolean,
    isExternalPurchasable: Boolean,
    price: Number,
    priceCostMultiplier: Number,
    screenPrice: Number,
    cost: Number,
    priceType: Number,
    fundAmount: Number,
    commissionAmount: Number,
    vdProducrtWarnings: Array,
    selectedDataPrice: Number,
    selectedDataPriceCostMultiplier: Number,
    selectedDataScreenPrice: Number,
    selectedDataCost: Number,
    selectedDataFundAmount: Number,
    selectedDataCommissionAmount: Number,
    selectedDataVdProducrtWarnings: Array,
    additionalWarnings: Array,
    selectedShortContent: String,
    selectedDescription: String,
    shortContent: String,
    description: String,
    selectedDataApplication: Object,
    filterAttribute: Array,
  },
  data() {
    return {
      selectedDataAppVal: "",
      clickedNewBtn: this.clickedNewItemBtn,
      invalidMessage: "Bu alan boş bırakılamaz!",
      selectedAppGroupOptions: [],
      submitted: false,
      formItems: {
        application: this.selectedDataApplication,
        applicationId: this.selectedDataApplicationId,
        id: this.selectedDataId,
        name: this.selectedDataName,
        order: this.selectedDataOrder,
        shortContent: this.selectedShortContent,
        description: this.selectedDescription,
        price: this.selectedDataPrice,
        priceCostMultiplier: this.selectedDataPriceCostMultiplier,
        screenPrice: this.selectedDataScreenPrice,
        cost: this.selectedDataCost,
        fundAmount: this.selectedDataFundAmount,
        commissionAmount: this.selectedDataCommissionAmount,
        vdProducrtWarnings: this.additionalWarnings,
        year: null,
        month: null,
      },
      selectedImage: "",
    };
  },
  components: {
    BaseSelect,
    BaseInput,
    BaseButton,
    BaseIcon,
    PhotoUpload,
  },
  computed: {
    ...mapGetters(["getFilterList", "getProductManagementResearchFilter"]),
    getResearchManagementFilter() {
      return this.getProductManagementResearchFilter;
    },
  },
  methods: {
    calculate(price) {
      this.formItems.commissionAmount = Math.round(
        Number(price) * Number(this.formItems.priceCostMultiplier)
      );
      let calculatedFundAmount =
        (Number(this.formItems.commissionAmount) / 0.7) * 1200;

      this.formItems.fundAmount = this.integersToRound(
        calculatedFundAmount,
        String(this.formItems.commissionAmount).length
      );
    },
    setPhotoForForm(base64) {
      this.formItems.imageFileBase64 = base64;
    },
    getFilter() {
      this.selectedAppGroupOptions = this.getFilterList.filter(
        (o) => o.name === "Applications"
      )[0].values;
      const firstItem = this.selectedAppGroupOptions.filter(
        (x) => x.code === 0
      );
      if (firstItem.length === 0) {
        this.selectedAppGroupOptions.unshift({
          code: 0,
          label: "Ana Ürün",
        });
      }
      if (this.clickedNewItemBtn) {
        this.formItems.applicationId = 0;
        this.formItems.application = this.selectedAppGroupOptions[0].label;
      }
    },
    addRemoveAdditionalWarnings(index = null) {
      if (index === null) {
        this.additionalWarnings.push("");
      } else {
        this.additionalWarnings.splice(index, 1);
      }
    },
    changeSelectedApp(value) {
      this.formItems.applicationId = value.code;
      this.formItems.application = value.label;
    },
    sendForm() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.formItems.id = Number(this.formItems.id);
      this.formItems.applicationId =
        Number(this.formItems.applicationId) === 0
          ? this.selectedAppGroupOptions[0].code
          : Number(this.formItems.applicationId);
      this.formItems.researchId = this.selectedDataResearchId;
      this.formItems.order = Number(this.formItems.order);
      this.formItems.price = Number(this.formItems.price);
      this.formItems.priceCostMultiplier = Number(
        this.formItems.priceCostMultiplier
      );
      this.formItems.screenPrice = Number(this.formItems.screenPrice);
      this.formItems.cost = Number(this.formItems.cost);
      this.formItems.fundAmount = Number(this.formItems.fundAmount);
      this.formItems.commissionAmount = Number(this.formItems.commissionAmount);
      if (
        this.formItems.vdProducrtWarnings.length === 1 &&
        this.formItems.vdProducrtWarnings[0] === ""
      ) {
        this.formItems.vdProducrtWarnings = [];
      }
      if (this.clickedNewItemBtn) {
        delete this.formItems.id;
        delete this.formItems.order;
        delete this.formItems.researchId;
      }
      if (this.formItems.applicationId === 0) {
        delete this.formItems.applicationId;
      }
      this.formItems.year = this.getResearchManagementFilter.year;
      this.formItems.month = this.getResearchManagementFilter.month;

      this.$emit("submit-form", this.formItems);
    },
  },
  mounted() {
    this.getFilter();
  },
  watch: {
    getResearchManagementFilter: {
      handler: function (newVal) {
        this.formItems.year = newVal.year;
        this.formItems.month = newVal.month;
      },
    },
  },
  validations: {
    formItems: {
      name: { required },
      price: { required },
      priceCostMultiplier: { required },
      screenPrice: { required },
      cost: { required },
      fundAmount: { required },
      commissionAmount: { required },
    },
  },
};
</script>
<style lang="scss" scoped>
.product-managements-container {
  .modal-body {
    .grouped-container {
      position: relative;
      &.with-button {
        width: 100%;
        .add-button {
          position: absolute;
          right: -14px;
          top: calc(50% - 10px);
          width: 35px;
          height: 35px;
          padding: 6px;
          border-radius: 4px;
          background-color: #242424;
          box-sizing: border-box;
          cursor: pointer;
          color: white;
          &.remove {
            background-color: #dc3545;
            color: white;
          }
        }
      }
      .title {
        position: absolute;
        top: -9px;
        left: 30px;
        font-weight: bold;
        font-size: 14px;
        color: #242424;
        background-color: white;
        padding: 0 8px;
      }
    }
    .upload-container {
      padding: 10px 10px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      input {
        display: none;
      }
      .content-item {
        .dummy-image {
          width: 58px;
          height: 58px;
          border-radius: 3px;
          background-color: #f3f3f3;
          background-position: center center;
          background-size: cover;
          padding: 17px 17px;
          box-sizing: border-box;
          cursor: pointer;
          .plus {
            color: #b9b9b9;
          }
        }
      }
    }
    .form-group {
      width: 93%;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
.invalid-feedback {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  padding-left: 10px;
}
.is-invalid {
  input {
    border: 1px solid red !important;
  }
}
</style>
